import React, { PropsWithChildren, useMemo, useState } from 'react';
import {
  ScreenWrapper,
  ScreenWrapperProps,
} from '../screen-wrapper/screen-wrapper';
import { SideDrawer, SideDrawerProps } from '../side-drawer/side-drawer';
import { HeaderProps } from '../header/header';
import {
  APP_TYPE,
  getWorkspace,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { FilterProps } from '../../types';

type BaseLayoutProps = PropsWithChildren<{
  headerProps: HeaderProps;
  screenProps?: Omit<ScreenWrapperProps, 'headerProps' | 'children'>;
  filterProps?: FilterProps;
  appType: APP_TYPE;
  drawerProps?: Partial<Omit<SideDrawerProps, 'appType'>>;
}>;

export const BaseLayout: React.FC<BaseLayoutProps> = ({
  children,
  screenProps,
  headerProps,
  filterProps,
  appType,
  drawerProps,
}) => {
  const workspace = useAppSelector(getWorkspace);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const hasCustomLeftIcon = !!headerProps.leftIcon?.icon;
  const useDrawer = headerProps.layout?.usingBaseLayout ?? !hasCustomLeftIcon;

  const combinedHeaderProps = useMemo<HeaderProps>(() => {
    return {
      ...headerProps,
      leftIcon: {
        ...headerProps.leftIcon,
        onPress: useDrawer
          ? () => setDrawerOpen(true)
          : headerProps.leftIcon?.onPress,
      },
      layout: {
        usingBaseLayout: useDrawer,
        workspace: { ...workspace },
        appType,
      },
    };
  }, [headerProps, workspace, appType]);

  return (
    <>
      <ScreenWrapper
        {...screenProps}
        headerProps={combinedHeaderProps}
        chipFilters={filterProps?.chipFilters}
        selectCheckbox={filterProps?.selectCheckbox}
      >
        {children}
      </ScreenWrapper>

      <SideDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        appType={appType}
        {...drawerProps}
      />
    </>
  );
};
